import React, { Suspense } from "react";
import {ContextMenuManager, ContextMenuType} from "./ContextMenuManager";


import {ItemContextMenu} from "./ItemContextMenu/ItemContextMenu";
import {WorkspaceContextMenu} from "./WorkspaceContextMenu/WorkspaceContextMenu";
import {AddToClusterContextMenu} from "./AddToClusterContextMenu/AddToClusterContextMenu";
import {DocumentContextMenu} from "./DocumentContextMenu/DocumentContextMenu";
import {SelectOptions} from '../../components/form/Select/SelectOptions';
import {CalendarSelectOptions} from "../../components/form/CalendarSelect/CalendarSelectOptions";
import {CalendarSelectRepeatOptions} from "../../components/form/CalendarSelect/CalendarSelectRepeatOptions";
import {AvatarUploadContextMenu} from "./AvatarUploadContextMenu/AvatarUploadContextMenu";
import {NotificationPanel} from "./NotificationPanel";
import {AcknowledgmentContextMenu} from "./AcknowledgmentContextMenu/AcknowledgmentContextMenu";
import {AvatarGroupUsersContextMenu} from "./AvatarGroupUsersContextMenu/AvatarGroupUsersContextMenu";
import {TreeQuickActionsContextMenu} from "./TreeQuickActionsContextMenu/TreeQuickActionsContextMenu";
import {ProfileContextMenu} from "./ProfileContextMenu/ProfileContextMenu";

const TextToolbar = React.lazy(() => import("./editor/TextToolbar/TextToolbar").then(m => ({default: m.TextToolbar})));
const TriggerToolbar = React.lazy(() => import("./editor/TriggerToolbar/TriggerToolbar").then(m => ({default: m.TriggerToolbar})));
const TableToolbar = React.lazy(() => import("./editor/TableToolbar/TableToolbar").then(m => ({default: m.TableToolbar})));
const ImageToolbar = React.lazy(() => import("./editor/ImageToolbar/ImageToolbar").then(m => ({default: m.ImageToolbar})));
const EmbedToolbar = React.lazy(() => import("./editor/EmbedToolbar/EmbedToolbar").then(m => ({default: m.EmbedToolbar})));
const CalloutToolbar = React.lazy(() => import("./editor/CalloutToolbar/CalloutToolbar").then(m => ({default: m.CalloutToolbar})));
const LinkInContextEditBar = React.lazy(() => import("./editor/LinkInContextEditBar/LinkInContextEditBar").then(m => ({default: m.LinkInContextEditBar})));
const PlusToolbar = React.lazy(() => import("./editor/PlusToolbar/PlusToolbar").then(m => ({default: m.PlusToolbar})));


export const MainContextMenuManager = () => {
    return (
        <ContextMenuManager renderContextMenu={renderContextMenu}/>
    );
}


function renderContextMenu(type: ContextMenuType, params: any, handleClose: any, isDark?: boolean) {
    switch (type) {
        case 'item':
            return <ItemContextMenu {...params} handleClose={handleClose}/>;
        case 'avatar':
            return <AvatarUploadContextMenu {...params} handleClose={handleClose} isDark={isDark}/>
        case 'document':
            return <DocumentContextMenu {...params} handleClose={handleClose}/>;
        case 'workspace':
            return <WorkspaceContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;

        case 'notification-centre':
            return <NotificationPanel/>
        case 'add-to-cluster':
            return <AddToClusterContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'editor-text':
            return (
                <Suspense fallback={null}>
                    <TextToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-trigger':
            return (
                <Suspense fallback={null}>
                    <TriggerToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-table':
            return (
                <Suspense fallback={null}>
                    <TableToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-image':
            return (
                <Suspense fallback={null}>
                    <ImageToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-callout':
            return (
                <Suspense fallback={null}>
                    <CalloutToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-embed':
            return (
                <Suspense fallback={null}>
                    <EmbedToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-link':
            return (
                <Suspense fallback={null}>
                    <LinkInContextEditBar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'editor-plus':
            return (
                <Suspense fallback={null}>
                    <PlusToolbar {...params} handleClose={handleClose} isDark={isDark}/>
                </Suspense>
            );
        case 'select-options':
            return <SelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'calendar-select-options':
            return <CalendarSelectOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'calendar-select-repeat-options':
            return <CalendarSelectRepeatOptions {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'acknowledgments-overview':
            return <AcknowledgmentContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'avatar-group-users':
            return <AvatarGroupUsersContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'tree-quick-actions':
            return <TreeQuickActionsContextMenu {...params} handleClose={handleClose} isDark={isDark}/>;
        case 'profile':
            return <ProfileContextMenu {...params} handleClose={handleClose}/>;
        default:
            return null;
    }
}
